import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


const TipologySearchSection: React.FC = () => {
    const { t } = useTranslation();

    // Titolo animazione
    const [boxVisible, setBoxVisible] = useState(false);
    const searchBox = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
            const handleScroll = () => {
                // Calcola la posizione dell'elemento
                const coordinates = searchBox.current?.getBoundingClientRect();
                // Calcola posizione nella viewport
                const positionInDOM = coordinates ? coordinates.bottom + window.scrollY : 0
                // Calcola il punto più basso della viewport
                const clientViewHeight = window.scrollY + window.innerHeight;
                if( positionInDOM-250 < clientViewHeight){
                    setBoxVisible(true);
                };
            }
    
            window.addEventListener("scroll", handleScroll);
            handleScroll();
    
            return () => {
                window.removeEventListener("scroll", handleScroll);
            }
        }, [])

        
    return (
        <section id="searchForTipology" className="space-ptb">
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 text-center">
                        <h2>{t('homePage.searchForTipo.title')}</h2>
                        <p className="lead">{t('homePage.searchForTipo.subTitle')}</p>
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.searchForTipo.para1') as string }}></p>
                    </div>
                </div>
                <div className={`row p-3 ${boxVisible ? "visible" : ""}`} ref={searchBox}>
                    <div className="col-12 col-lg-4 p-0 agent-box">
                        <div className="text-center p-3">
                            <h3 className="mb-3">Immobiliare Marzocchi</h3>
                            <p>Hai bisogno di un aiuto in più?</p>
                            <p>I nostri agenti sono qui per suppertarti nella ricerca</p>
                            <Link to="/contatti" className="btn btn-primary text-uppercase">
                                Contattaci
                            </Link>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8 tipologies-box">
                        <div className="row">
                            <div className="col-12 col-md-6 p-0">
                                <Link to="immobili/appartamento">
                                    <span>Appartamento</span>
                                </Link>
                            </div>
                            <div className="col-12 col-md-6 p-0">
                                <Link to="immobili/casa-singola">
                                    <span>Casa Singola</span>
                                </Link>
                            </div>
                            <div className="col-12 col-md-6 p-0">
                                <Link to="/immobili/rustico">
                                    <span>Rustico</span>
                                </Link>
                            </div>
                            <div className="col-12 col-md-6 p-0">
                               <Link to="immobili/attivita-commerciale">
                                    <span>Attività</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TipologySearchSection;
